<app-content *ngIf="initialized" class="cms_component"></app-content>
